import { DataSource } from "../../Data/DataSource";
import { Nullable, PartialNullable } from "../../Extensions";
import { ObjectHelper } from "../../Helpers/ObjectHelper";
import { StringHelper } from "../../Helpers/StringHelper";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { LookupItemCache } from "../../Server/LookupItemCache";
import { ComboBox, ComboBoxPropertyValues, IComboBox } from "./ComboBox";
import { NAMESPACE } from "./_Namespace";

export type ComboBoxLookupItemPropertyValues =
    ComboBoxPropertyValues
    & {
        lookupType: string;
        orderBy: "description" | "order";
    };

export type ComboBoxLookupItemProperties = {
    [name in keyof ComboBoxLookupItemPropertyValues]: Property<ComboBoxLookupItemPropertyValues[name]>
};

export interface IComboBoxLookupItem extends IComboBox, ComboBoxLookupItemProperties
{
}

export class ComboBoxLookupItem extends ComboBox implements IComboBoxLookupItem
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ComboBoxLookupItem";
    public static override className = "ComboBoxLookupItem";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ComboBoxLookupItemPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public lookupType!: PropertyString;
    public orderBy!: Property<"description" | "order">;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ComboBoxLookupItemPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Public Methods

    public async loadDataAsync()
    {
        const
            lookupType = this.lookupType.get(),
            orderBy = this.orderBy.get(),
            dataSourceProperty = this.dataSourceProperty.get(),
            dataSource = this.dataSource.get(),
            requiredId: Nullable<string> = (dataSourceProperty && dataSource ? dataSource.propertyValueByPathGet(dataSourceProperty) : null) ?? null,
            lookupItems = await LookupItemCache.getByTypeAsync(lookupType, requiredId, orderBy);

        this.listDataSource.set(new DataSource({ data: lookupItems.map(item => ({ value: item.id, description: item.description })) }));
        this.triggerHandler("listDataSourceChanged");
    }

    // #endregion

    // #region Protected Methods

    protected _lookupTypeChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _orderByChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ComboBoxLookupItemPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.lookupType = new PropertyString(this, propertyValues.lookupType, this._lookupTypeChanged);
        this.orderBy = new Property<"description" | "order">(this, "System.String, System.Private.CoreLib", propertyValues.orderBy, this._orderByChanged);
    }

    // #endregion

    // #endregion
}

